var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('navigation', {
    attrs: {
      "visible": _vm.hasNav
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "app__wrapper"
  }, [(_vm.hasLayout) ? _c('main', {
    staticClass: "app__main app__main--with-layout",
    class: {
      'app__main--with-nav': _vm.hasNav
    }
  }, [(_vm.isAuthenticated) ? _c('div', {
    staticClass: "uk-container app__container"
  }, [_c('breadcrumbs'), _vm._v(" "), _c('router-view')], 1) : _c('div', {
    staticClass: "app__container--loading uk-text-center uk-margin-medium-top"
  }, [_c('loader')], 1)]) : _c('main', {
    staticClass: "app__main",
    class: {
      'app__main--with-nav': _vm.hasNav
    }
  }, [_c('router-view')], 1)])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e4360e2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./views/App.vue
// module id = 1918
// module chunks = 0